/**
 * @Author: v_jppjpeng
 * @Date: 2022-12-29 14:54:30
 * @Explain: axios - 统一处理
 */
import axios, { AxiosInstance } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
  axiosBaseURL,
  beforeReqTimeMark,
  onResError,
  onResSuccess,
  setReqConfig,
} from './interfaceUtils';
// smlMonitor
import { smlMonitor } from '@/utils/smlMonitor';
// utils
import { API, isDev } from '@/config';

class AxiosService {
  public axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: isDev ? axiosBaseURL : API.apiHost + axiosBaseURL,
      // timeout: 100 * 1000, // 100S
    });
    this.setInterceptorsReq();
    this.setInterceptorsRes();
  }
  // 添加拦截器
  private setInterceptorsReq = () => {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        // 请求前配置 记录请求
        const key = `${config.url}-${uuidv4()}`;
        config['designReportKey'] = key;
        config[beforeReqTimeMark] = new Date().valueOf();
        smlMonitor?.setNetworkInfo(key, true);
        return setReqConfig(config);
      },
      (error) => {
        // 异常时 删除
        smlMonitor?.delNetworkCount(error?.config?.designReportKey);
        console.error('request.use', error);
        return Promise.reject(error);
      },
    );
  };

  private setInterceptorsRes = () => {
    this.axiosInstance.interceptors.response.use(
      (response) => {
        // 完成时 删除
        smlMonitor?.delNetworkCount(response?.config?.designReportKey);
        return onResSuccess(response);
      },
      (error) => {
        // 异常时 删除
        smlMonitor?.delNetworkCount(error?.config?.designReportKey);
        let config: any = error?.config;
        // 是否弹出error提示框拦截
        let unUseCommonMsg = config?.params?.unUseCommonMsg;
        if (!unUseCommonMsg) onResError(error);
        return Promise.reject(error);
      },
    );
  };
}

export default new AxiosService().axiosInstance;
